import { useContext } from "react";
import { Shops } from "Context/context";

export default function useShops() {
  return useContext(Shops);
}
